import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function Integrations() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Admin / Integrations";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <h1 className="mb-0">Integrations</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default Integrations;
